export default "__VITE_ASSET__DPddCyFP__"